var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cba9de03115752af6e031ed658cd4a9951436610"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pilot-web@pilot-institute"]={id:"cba9de03115752af6e031ed658cd4a9951436610"};
      